var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconRotation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_435_214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.6474 25.9687C18.775 25.9896 18.8973 26 19.0196 26C19.9608 26 20.7584 25.3419 20.9817 24.4384C21.7686 21.2317 23.9912 13.5649 23.9912 11.5803C23.9912 9.0525 21.9016 7 19.328 7C18.674 7 18.0519 7.13057 17.4883 7.37081C17.0151 7.56927 16.5046 7.67372 15.9941 7.67372C15.4837 7.67372 14.9732 7.57449 14.5 7.37081C13.9364 7.13057 13.3143 7 12.6603 7C10.0867 7 7.99707 9.0525 7.99707 11.5803C7.99707 13.3194 10.1984 21.2317 10.9694 24.4384C11.1874 25.3419 11.985 26 12.9314 26C13.0537 26 13.1813 25.9896 13.309 25.9634C14.2661 25.7859 14.9307 24.9241 14.9307 23.9684V21.7905C14.9307 20.9601 15.3986 20.5006 15.9782 20.5006C16.5578 20.5006 17.0257 20.9601 17.0257 21.5294V23.9684C17.0257 24.9241 17.6903 25.7911 18.6528 25.9687H18.6474Z",
    fill: "#70A4D4"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 4,
    x2: 16,
    y2: 27,
    stroke: "#1A1A1A",
    strokeDasharray: "2 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.0116854 10L-0.282543 15.766L4.85807 13.1378L0.0116854 10ZM32 10L27.1099 13.0692L32.2129 15.7696L32 10ZM1.73954 14.3907C3.85025 16.1573 7.8668 17.7687 15.4909 17.9998L15.5212 17.0002C7.99935 16.7722 4.24546 15.184 2.38136 13.6239L1.73954 14.3907ZM15.4909 17.9998C23.752 18.2502 28.0262 16.3907 30.2349 14.3446L29.5553 13.611C27.6121 15.4111 23.6397 17.2463 15.5212 17.0002L15.4909 17.9998Z",
    fill: "#1A1A1A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_435_214"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#1A1A1A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRotation);
export default __webpack_public_path__ + "static/media/Icon_Rotation.23847133ba9f0e1f7517065dd314801c.svg";
export { ForwardRef as ReactComponent };